import { Link } from "react-router-dom";
export default function Features() {
    return (
        <main className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
            <h1 className="text-3xl font-bold text-gray-900">Features</h1>
            <p className="mt-4 text-gray-700 max-w-3xl">
                SecureID Technologies products and services are built with security,
                compliance, and ease of use at the core. Explore what makes us different.
            </p>

            <section className="mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
                <div className="rounded-xl border p-6 shadow-sm">
                    <h2 className="text-xl font-semibold">Security & Compliance</h2>
                    <ul className="mt-3 list-disc pl-5 text-gray-700 space-y-2">
                        <li>FBI EBTS & FDLE compliant workflows</li>
                        <li>Encryption at rest & in transit</li>
                        <li>Audit logs & role-based access</li>
                    </ul>
                </div>

                <div className="rounded-xl border p-6 shadow-sm">
                    <h2 className="text-xl font-semibold">Technology Capabilities</h2>
                    <ul className="mt-3 list-disc pl-5 text-gray-700 space-y-2">
                        <li>Offline-first exam platform</li>
                        <li>Biometric & e-signature integrations</li>
                        <li>Multi-tenant SaaS cloud architecture</li>
                    </ul>
                </div>

                <div className="rounded-xl border p-6 shadow-sm">
                    <h2 className="text-xl font-semibold">User Experience</h2>
                    <ul className="mt-3 list-disc pl-5 text-gray-700 space-y-2">
                        <li>Candidate-friendly exam navigation</li>
                        <li>HR-friendly onboarding workflows</li>
                        <li>Reporting & exports (CSV, XML)</li>
                    </ul>
                </div>

                <div className="rounded-xl border p-6 shadow-sm">
                    <h2 className="text-xl font-semibold">Customization</h2>
                    <ul className="mt-3 list-disc pl-5 text-gray-700 space-y-2">
                        <li>White-label branding</li>
                        <li>Modular deployment (standalone or bundled)</li>
                        <li>Custom Avaya IVR call flows</li>
                    </ul>
                </div>

                <div className="rounded-xl border p-6 shadow-sm">
                    <h2 className="text-xl font-semibold">Support & Services</h2>
                    <ul className="mt-3 list-disc pl-5 text-gray-700 space-y-2">
                        <li>Dedicated onboarding & training</li>
                        <li>Avaya Aura® consulting contracts</li>
                        <li>Flexible subscription or project models</li>
                    </ul>
                </div>
            </section>

            {/* Back to Home link */}
            <p className="mt-10 text-center text-sm text-gray-600">
                <Link to="/" className="text-indigo-600 hover:underline">
                    ← Back to Home
                </Link>
            </p>
        </main>
    );
}
